/*
Documentation

This file renders the Article site page

*/

import React from "react";
import { Helmet } from 'react-helmet';
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { architeckCall } from 'database';
import { toggleAlert } from 'store/functions/system';
import { Redirect } from 'react-router-dom';
import HeroHalf from 'components/markup/heros/Half';
import reactHTMLParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import archkFormatString from 'architeck-format-string';
import { connect } from 'react-redux';
import moment from 'moment';

class Article extends React.Component {

    state = {
        articles: [],
        article: {
            post_author: 0
        }
    }

    componentWillMount = () => {
        this.fetchData(this.props)
    }

    componentWillReceiveProps = (nextProps) => {
        this.fetchData(nextProps)
    }

    fetchData = async (props) => {

        const _id = props.match.params._id;

        if(!_id) {
            this.setState({shouldRedirect: '/'});
            return;
        }

        if(props.app_articles && props.app_articles.length) {

            let article = props.app_articles.find(a => a._id === _id) 

            if(!article) {
                this.setState({shouldRedirect: '/'})
            }

            this.setState({article, articles: props.app_articles, loaded: true})

        } else {

            const article = await architeckCall({
                method: 'get',
                url: '/api/v1/archk_articles/find/' + _id,
            })
    
            if(article.success) {
                this.setState({article: article.data, loaded: true})
            } else {
                toggleAlert(true, 'warning', `Error: ${article.message}.`, 'infinite' )
            }
    
            const articles = await architeckCall({
                method: 'get',
                url: '/api/v1/archk_articles/list/?limit=10&find_by=post_status__published',
            })
    
            if(articles.success) {
                this.setState({articles: articles.data, loaded: true})
            } else {
                toggleAlert(true, 'warning', `Error: ${articles.message}.`, 'infinite' )
            }

        }

       

    }

    render() {

        if(this.state.shouldRedirect) {
            return <Redirect to={this.state.shouldRedirect} />
        }

        const article = this.state.article
        const articles = this.state.articles

        console.log(articles)
        
        return (
        <>

            <Helmet>
                <title>{article.post_name}</title>
                <meta name="description" content={article.post_name} />
            </Helmet>

            <div className="main-content articles article-post">

                <HeroHalf filter={.7} padding={window.innerWidth > 600 ? 100 : 50} theme="dark" img={article.post_image}>
                    <Container>

                        <Row>
                            <Col lg={7} mg={7}>
                                <h1 className="display-1 text-white">{article.post_name}</h1>
                                <p className="text-white">Published On: { moment.unix(article.created_at).format("MMM D, YYYY")}</p>
                            </Col>
                        </Row>

                      
                    </Container>
                </HeroHalf>

                <section className="py-6  bg-white">
                    <Container>

                        <Row>
                            <Col lg={8}>
                                {reactHTMLParser(article.post_content)}
                            </Col>

                            <Col lg={4}>
                                {articles && articles.length ? articles.slice(0, 4).map(a => (
                                    a._id === this.props.match.params._id ? null : (
                                        <div className="article-card">
                                            <Link to={`/article/${a._id}`} >
                                                <div className="image" style={{ backgroundImage: 'url("'+a.post_image+'")'}} />
                                            </Link>

                                            <Card>
                                                <CardHeader>
                                                    <h3 className="mb-0">{a.post_name}</h3>
                                                </CardHeader>
                                                <CardBody>
                                                    <p className="">{archkFormatString(a.post_excerpt, 100, true)}...</p>
                                                    <p className="text-sm">By <b>{a.post_author.given_name} {a.post_author.family_name}</b> on { moment.unix(a.created_at).format("MMM D, YYYY")}</p>

                                                    <div className="text-right">
                                                        <Link to={`/article/${a._id}`} className="mt-2 btn btn-success btn-sm">Read More</Link>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    ) 
                                    
                                )) : null}
                            </Col>

                        </Row>

                    </Container>
                </section>

                <section className="py-6">
                    <Container>
                        <Row>
                            <Col md={3} className="align-self-center">
                                <span style={{display: 'inline-block'}} className="mr-3">
                                    <img style={{width: 50, borderRadius: 50, marginTop: -20}} src={article.post_author.picture_url} alt="" />
                                </span>
                                <span style={{display: 'inline-block', paddingTop: 0}}>
                                    <span className="">
                                        Author <br /> 
                                        <b >{article.post_author.given_name} {article.post_author.family_name}</b>
                                    </span>
                                </span>
                            </Col>
                            <Col md={9}>
                                <p>There is nothing I have more passion for then helping businesses and entrepreneurs create the systems that change lives. Both for themselves, their families, and the people that depend on them. That's what drives me every day to deliver the best products and services out there, day in and day out.</p>
                            </Col>
                        </Row>
                    </Container>
                </section>


            </div>
        </>
        );
    }
}

const mapStateToProps = state => {

    return {
  
      app_articles: state.articles.app_articles,
  
    };
};
  
export default connect(mapStateToProps, '')(Article);